import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ACCESS_TOKEN = 'APEX2026';
const STORAGE_KEY = 'apex_access_granted';
const STORAGE_TTL = 24 * 60 * 60 * 1000; // 24h

function checkAccess() {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('access') === ACCESS_TOKEN) {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
      return true;
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && Date.now() - parseInt(stored, 10) < STORAGE_TTL) return true;
  } catch (_) { /* ignore */ }
  return false;
}

/**
 * Gate wrapper for /lens/* product routes.
 * Public visitors WITHOUT an access grant get bounced to the home page with
 * ?gate=lens&from=<path>, which Home.jsx reads to auto-open the AccessRequestModal.
 * Design partners hitting /demo/* keep their pre-shared private URL behavior.
 */
export default function LensGate() {
  const location = useLocation();
  const allowed = checkAccess();

  useEffect(() => {
    if (!allowed) {
      // Light analytics breadcrumb in the console for debugging the gate.
      // eslint-disable-next-line no-console
      console.info('[apex-gate] blocked', location.pathname);
    }
  }, [allowed, location.pathname]);

  if (!allowed) {
    const isDemo = location.pathname.startsWith('/demo');
    const from = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?gate=${isDemo ? 'demo' : 'lens'}&from=${from}`} replace />;
  }
  return <Outlet />;
}
